<div class="text-right clearfix">
  <h2 class="pull-left">Emoji</h2>
  @for (tone of tones; track tone) {
    <span
      class="emoji-tone-picker"
      [ngClass]="{active: tone === activeTone, clickable: activeCategory === 'activity' || activeCategory === 'people'}"
      (click)="setActiveTone(tone)"
      [innerHTML]="shortnameToImageHtml(':' + tone + ':')">
    </span>
  }
</div>
<ul class="nav nav-tabs">
  @for (category of getCategoryKeys(); track category) {
    <li [ngClass]="{active: category === activeCategory}">
      <a [uiSref]="'emoji.category'" [uiParams]="{category: category}">{{ category | capitalize }}</a>
    </li>
  }
</ul>
<div class="tab-content mt4">
  <div class="clearfix">
    <ul class="emoji-list">
      @for (emo of emojiByCategory[activeCategory]; track emo) {
        <li [hidden]="!toneCheck(emo)">
          <span [innerHTML]="shortnameToImageHtml(emo.shortname)"></span>
          <code utClipboard [attr.data-clipboard-text]="emo.shortname">{{ emo.shortname }}</code>
        </li>
      }
    </ul>
  </div>
</div>
